import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import organizationTypes from "astrid-firestore/src/api/organizations/constants/organizationTypes";
import useCollectionData from "astrid-firestore/src/hooks/useCollectionData";

import Table from "../../../tables/components/Table";

import HomeLayout from "../../layouts/HomeLayout/HomeLayout";

import useMyProductionsColumns from "./hooks/useMyProductionsColumns";
import useMyProductionsQuery from "./hooks/useMyProductionsQuery";

export default function MyProductionsWidget({ organization, language }) {
	const { t } = useTranslation();

	const navigate = useNavigate();

	const [productions = [], loading, error] = useCollectionData(useMyProductionsQuery({ organization }));

	const filteredProductions = productions?.filter((production) => !language || production.language === language);

	const defaultSort = organization?.type === organizationTypes.PUBLISHER ? "deliveryDate" : "productionDate";

	const columns = useMyProductionsColumns();

	const getDropdownMenuOptions = (production) => [
		{
			text: t("toProduction", "To production"),
			linkTo: `/production/${production.id}`,
		},
	];

	filteredProductions.sort((a, b) => {
		if (a[defaultSort] && b[defaultSort]) {
			return a[defaultSort].toDate() - b[defaultSort].toDate();
		}

		if (a[defaultSort]) {
			return -1;
		}

		if (b[defaultSort]) {
			return 1;
		}

		return 0;
	});

	return (
		<HomeLayout.Widget icon="clipboard list" color="green" header={t("myProductions", "My productions")}>
			<Table
				data={filteredProductions}
				error={error}
				columns={columns}
				loading={loading}
				onClick={({ id }) => navigate(`/production/${id}`)}
				getDropdownMenuOptions={getDropdownMenuOptions}
				noDataAvailableMessage={t("noOngoingProductions", "You are not a part of any ongoing productions")}
			/>
		</HomeLayout.Widget>
	);
}
